// extracted by mini-css-extract-plugin
export default {"upcomingDevTitle":"UpcomingWork_upcomingDevTitle__iw3cD","table":"UpcomingWork_table__6Dlyq"};